import { Box, FlexColumn, PopupDialog } from "designSystem/index";
import DojoView from "csi/page/DojoView";
import React, { useState } from "react";
import { FunctionComponent, useEffect } from "react";
import { ControllerProps } from "csi/middleware/common";
import { routerStore } from "csi/state/rootStore";
import { ReactionStore } from "csi/utility/mobxUtility";
import def from "csi/def";
import reflection from "csi/reflection";
import { View } from "csi/def/View";
import { reaction } from "mobx";

function defProofProgressView(): View {
	const rc = reflection.getClass("ProofWorkflowInstance");
	const defView = def.getClassViewDef(rc, "ProofProgress") as View;
	return defView;
}

function defProofStatusView(): View {
	const rc = reflection.getClass("ProofWorkflowHolder");
	const defView = def.getClassViewDef(rc, "ProofingStatus") as View;
	return defView;
}

export const ProofingProgressPopUp: FunctionComponent<ControllerProps> = (props) => {
	const { actionController, onClose } = props;
	const [open, setOpen] = useState<boolean>(true);
	const revisionNode = actionController.getNode().CurrentRevision;
	const proofWorkflow = actionController.getNode().ProofWorkflow;
	const defProgressView = defProofProgressView();
	const defStatusView = defProofStatusView();

	function _onClose() {
		setOpen(false);
		onClose();
	}

	useEffect( () => {
		const reactionStore = new ReactionStore();
		reactionStore.trackReaction(reaction(() => routerStore.locationNode, _onClose));	
	}, []);


	return (
		<PopupDialog
			onClose={_onClose}
			open={open}
			titleRes="PopupProofProgress_Title"
		>
			{{
				main: (
					<FlexColumn p={5}>
						<Box growNoOverflow>
							<DojoView
								fullHeight
								nodeUrl={revisionNode}
								viewId="ProofingStatus"
								viewNodeType="ProofWorkflowHolder"
								viewParams={{
									defStatusView,
								}}
							/>
						</Box>
						<Box growNoOverflow>
							<DojoView
								fullHeight
								nodeUrl={proofWorkflow}
								viewId="ProofProgress"
								viewNodeType="ProofWorkflowInstance"
								viewParams={{
									defProgressView,
								}}
							/>
						</Box>
					</FlexColumn>
				),
			}}
		</PopupDialog>
	);
};

export default ProofingProgressPopUp;